import { useSelector } from 'react-redux';
import { price } from 'utils/helpers';
import { getTotalGiftCardAmount } from 'redux/selectors/checkout';
import {
  getAmountToPay,
  getCommissionAmount,
  getSurchargeAmount,
} from 'redux/selectors/current_booking';

const AmountToPay = () => {
  const amountToPay = useSelector(getAmountToPay);
  const surchargeAmount = useSelector(getSurchargeAmount);
  const commissionAmount = useSelector(getCommissionAmount);
  const giftCardAmount = useSelector(getTotalGiftCardAmount);
  const totalPrice = price(amountToPay + surchargeAmount);

  return (
    <>
      {Boolean(giftCardAmount) && (
        <div className="mb-3">
          You have redeemed{' '}
          <span className="fw-bold">{price(giftCardAmount)}</span> from your
          Brilliant gift card(s). Your remaining balance is{' '}
          <span className="fw-bold">{totalPrice}</span>
        </div>
      )}
      {!!commissionAmount && (
        <div className="text-end">
          <span className="text-large">Commission</span>
          <span className="text-large">&nbsp;{price(commissionAmount)}</span>
        </div>
      )}
      <div className="text-end">
        <span className="fw-bold text-x-large">Total</span>
        <span className="fw-bold text-xxx-large">&nbsp;{totalPrice}</span>
      </div>
    </>
  );
};

export default AmountToPay;
